import styles from "./index.module.scss"

interface ShareButtonProps {
    type: string
    onClick?: () => void
}

const ShareButton: React.FC<ShareButtonProps> = ({ type, onClick }) => (
    <button
        type="button"
        className={styles.shareButton}
        data-type={type}
        onClick={onClick}
    />
)

export default ShareButton
